import { Pagination } from "@/models/constant/interface/common.interface";
import {
  UploadTaxIncomeHistoryParams,
  UploadTaxIncomeHistoryResponseDto,
} from "@/models/interface/upload-tax-income/UploadTaxIncomeHistoryResponseDto.interface";
import { uploadTaxIncomeService } from "@/services/upload-tax-income.service";

const useUploadTaxIncome = () => {
  const downloadTemplate = (): Promise<Blob> => {
    return uploadTaxIncomeService.downloadTemplateTaxIncome();
  };

  const downloadTaxIncome = (path: string): Promise<Blob> => {
    return uploadTaxIncomeService.downloadTaxIncome(path);
  };

  const uploadData = (formData: FormData): Promise<void> => {
    return uploadTaxIncomeService.uploadTaxIncome(formData);
  };

  const historyUpload = (
    params?: UploadTaxIncomeHistoryParams
  ): Promise<Pagination<UploadTaxIncomeHistoryResponseDto>> => {
    return uploadTaxIncomeService.historyUpload(params);
  };

  const processTaxIncome = (id: string): Promise<void> => {
    return uploadTaxIncomeService.processTaxIncome(id);
  };

  return {
    downloadTemplate,
    uploadData,
    historyUpload,
    processTaxIncome,
    downloadTaxIncome,
  };
};

export { useUploadTaxIncome };
